<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" md="6" class="offset-md-3">
          <div class="pa-2 rounded elevation-1 bg-white">
            <div class="d-flex flex-start">
              <router-link class="sm-fullwidth" :to="{ name: 'Home' }">
                <v-btn color="primary-dark" block class="sm-fullwidth mt-2" variant="default" size="small"> <v-icon
                    icon="mdi-arrow-left-bold"></v-icon> Retour à l'accueil </v-btn>
              </router-link>
            </div>

            <div v-if="!success_change">
              <div class="text-h5 mt-3 mb-2">Réinitialisation de mon mot de passe</div>
              <div class="text-body mb-4">Veuillez saisir votre nouveau mot de passe pour le compte {{ user.mail }}
              </div>
              <v-form ref="reset_pass_form" v-model="reset_pass_form_valid">
                <label class="field_label">Mot de passe</label>
                <v-text-field v-model="user.pass" autocomplete="off" :rules="[$formRules.required, $formRules.password]"
                  :type="showpass ? 'text' : 'password'" :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showpass = !showpass"></v-text-field>
                <PasswordPolicyHints :password="user.pass" />
                <label class="field_label">Confirmer votre mot de passe</label>
                <v-text-field v-model="password_confirm" :rules="[$formRules.required]"
                  :type="showconfirmpass ? 'text' : 'password'"
                  :append-icon="showconfirmpass ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showconfirmpass = !showconfirmpass" autocomplete="off"></v-text-field>

                <v-alert color="dark-red" variant="tonal" density="compact" class="mb-4" v-if="errors" type="error">{{
                  errors }}</v-alert>
                <div class="d-flex w-100"></div>
                <v-btn color="primary-dark" block class="mt-2" @click="change_password()">Mettre à jour</v-btn>
              </v-form>
            </div>
            <div v-else>
              <div class="text-h5 mt-3 mb-2">Votre mot de passe a bien été mis à jour</div>
              <div class="text-body mb-4">Vous pouvez maintenant vous connecter avec votre nouveau mot de passe</div>
              <router-link class="sm-fullwidth" :to="{ name: 'Home' }">
                <v-btn color="primary-dark" block class="sm-fullwidth mt-2" variant="default" size="small"> <v-icon
                    icon="mdi-arrow-left-bold"></v-icon> Retour à l'accueil </v-btn>
              </router-link>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import UserAuthService from "@/services/user-auth.service.js";
import PasswordPolicyHints from "@/components/Authentification/PasswordPolicyHints.vue";
export default {
  components: { PasswordPolicyHints },
  data() {
    return {
      success_change: false,
      errors: "",
      showpass: false,
      showconfirmpass: false,
      password_confirm: "",
      reset_pass_form_valid: false,
      user: {
        mail: "",
        pass: "",
      },
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async change_password() {
      this.errors = "";
      const { valid } = await this.$refs.reset_pass_form.validate();
      if (!valid) {
        this.errors = "Certains champs sont invalides";
        return;
      }
      if (this.password_confirm != this.user.pass) {
        this.errors = "Les deux mots de passe sont différents";
        return;
      }
      const token = this.$route.query.r;
      let request = await UserAuthService.resetPassword(token, this.user);
      if (request.success) {
        this.success_change = true;
      } else {
        this.errors = request.error;
      }

    },
  },
  async created() {
    if (!this.$route.query.r || this.$route.query.r == "") {
      this.$router.push({ name: "Home" });
    }
    let request = await UserAuthService.decryptResetPassToken(this.$route.query.r);
    if (!request.success) {
      this.mainStore.notification.send("Le lien de réinitialisation de mot de passe est invalide", "error");
      this.$router.push({ name: "Home" });
      return;
    }
    this.user.mail = request.mail;
  },
};
</script>

<style lang="scss" scoped></style>